const digest = '0f8b6d7e3d3b8bd60c36607ab22fa698d37daa0b2b1893c9e41bb2e01238d206';
const css = `@font-face{font-display:swap;font-family:BigCaslon;font-weight:400;src:url(https://www.aexp-static.com/cdaas/one/statics/axp-static-assets/2.8.1/package/dist/fonts/bigcaslonregular.woff) format("woff"),url(https://www.aexp-static.com/cdaas/one/statics/axp-static-assets/2.8.1/package/dist/fonts/bigcaslonregular.woff2) format("woff2")}._centurionWordmark_1rczc_7{font-family:BigCaslon;font-size:1.7rem;font-weight:400;line-height:2.75rem}._centurionWordmark_1rczc_7 img{height:25px!important;width:auto!important}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'centurionWordmark': '_centurionWordmark_1rczc_7' };
export const centurionWordmark = '_centurionWordmark_1rczc_7';
export { css, digest };